import { Enum } from './enum';

export class UnAuthorisedErrors extends Enum<string> {
  public UnauthorizedMailCreationEntrant = new Enum('Impossible de créer un courrier entrant pour ce service.');
  public UnauthorizedMailCreationSortant = new Enum('Impossible de créer un courrier sortant pour ce service.');
  public UnauthorizedMailCreationInterne = new Enum('Impossible de créer un courrier interne pour ce service.');
  public UnauthorizedService = new Enum('Impossible de créer une fiche pour ce service');
  public UnauthorizedMailModification = new Enum('Impossible de modifier un courrier pour ce service.');
}
